import { jwtDecode } from "jwt-decode";

export const getDecodedToken = (jwtToken) => {
  if (!jwtToken) {
    return null;
  }

  try {
    const decoded = jwtDecode(jwtToken, { header: false });
    return decoded;
  } catch (error) {
    console.error("Invalid JWT token:", error);
    return null;
  }
};